<template>
  <div v-if="params">
    <span v-if="params">
      {{ params | dateFormat }}
    </span>
  </div>
</template>
<script>
export default {
  name: "LoadDates",
  props: {
    params: {
      type: String,
    },
  },
};
</script>

<style lang="scss" >
.expired-date {
  color: red;
}
</style>
